<template>
  <v-btn v-bind="$attrs" class="p-button" variant="tonal">
    <div>
      <slot></slot>
    </div>
  </v-btn>
</template>
